











































/* eslint-disable no-underscore-dangle */
import { defineComponent, computed, watch, ref } from '@vue/composition-api';
import { Location } from 'vue-router';

import { prompt } from '@/components/Prompt';
import store from '@/store';

import { csvExportDialog } from '../state';

export default defineComponent({
  name: 'csvExport',
  setup() {
    // Conditionally add motion header
    const outputData = ref({});
    const gridRef = ref(null);

    function closeDialog() {
      csvExportDialog.value = false;
    }

    function formatDateTime(dateString: string): string {
      const timestamp = Date.parse(dateString);
      if (Number.isNaN(timestamp)) {
        return '';
      }
      const date = new Date(dateString);
      return date.toLocaleString();
    }

    watch(csvExportDialog, async (open) => {
      if (!open) return;
      outputData.value = await store.dispatch.dataset.exportToCSV();
    });

    function exportCSV() {
      if (!gridRef.value) return;
      if (gridRef.value !== null) {
        // eslint-disable-next-line
        (gridRef as any).value.exportTable('csv', false, 'output.csv');
      }
    }

    return {
      closeDialog,
      formatDateTime,
      outputData,
      gridRef,
      csvExportDialog,
      exportCSV,
    };
  },
});
